export enum TipoExpedienteEnum {
    VICTIMAS_DESAPARECIDAS = "61ca6a2c70fe0ad1a970a24e",
    HALLAZGOS = "61ca6a2c70fe0ad1a970a251",
    DEMO = "650137a412deab7d0f8d5a21",
    DILIGENCIA = "62e01b27290223b7d52e990a"
}
